import { type AnnotationThread, AnnotationThreadSchema } from "../types";

const STORAGE_PREFIX = "magic_comment_embed_threads";

function sanitize(value: string): string {
  return value.replace(/[^a-zA-Z0-9/_-]/g, "_");
}

export function getThreadStorageKey(
  projectId: string,
  reviewId: string,
  pageId: string,
): string {
  return `${STORAGE_PREFIX}:${sanitize(projectId)}:${sanitize(reviewId)}:${sanitize(pageId)}`;
}

export function loadStoredThreads(
  projectId: string,
  reviewId: string,
  pageId: string,
): AnnotationThread[] {
  if (typeof window === "undefined") return [];

  try {
    const stored = localStorage.getItem(
      getThreadStorageKey(projectId, reviewId, pageId),
    );
    if (!stored) return [];
    const parsed: unknown = JSON.parse(stored);
    if (!Array.isArray(parsed)) return [];

    // Validate each record so a corrupt/legacy entry can't crash mount();
    // invalid records are dropped, valid ones are kept.
    return parsed.flatMap((entry): AnnotationThread[] => {
      const result = AnnotationThreadSchema.safeParse(entry);
      return result.success ? [result.data] : [];
    });
  } catch {
    return [];
  }
}

export function saveStoredThreads(
  projectId: string,
  reviewId: string,
  pageId: string,
  threads: AnnotationThread[],
): void {
  if (typeof window === "undefined") return;

  try {
    localStorage.setItem(
      getThreadStorageKey(projectId, reviewId, pageId),
      JSON.stringify(threads),
    );
  } catch {
    // Ignore storage failures.
  }
}

export function clearStoredThreads(
  projectId: string,
  reviewId: string,
  pageId: string,
): void {
  if (typeof window === "undefined") return;

  try {
    localStorage.removeItem(getThreadStorageKey(projectId, reviewId, pageId));
  } catch {
    // Ignore storage failures.
  }
}
